"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLocaleIdentifier = exports.defaultLocale = exports.buildLocale = exports.getLanguageCodeFromLocale = exports.getCountryCodeFromLocale = void 0;
var locale_1 = require("../locale");
var DEFAULT_LOCALE_ID = 'en_LI';
var DEFAULT_LOCALE_NAME = locale_1.languages.english.languageName;
var DEFAULT_LOCALE_LANGUAGE_CODE = locale_1.languages.english.languageCode;
var DEFAULT_LOCALE_COUNTRY_NAME = locale_1.allCountries.liechtenstein.countryName;
var DEFAULT_LOCALE_COUNTRY_CODE = locale_1.allCountries.liechtenstein.countryCode;
var DEFAULT_LOCALE_REGION_NAME = locale_1.regions.europe.regionName;
var DEFAULT_LOCALE_REGION_CODE = locale_1.regions.europe.regionCode;
var getCountryCodeFromLocale = function (localeId) {
    return localeId.split('_')[1];
};
exports.getCountryCodeFromLocale = getCountryCodeFromLocale;
var getLanguageCodeFromLocale = function (localeId) {
    return localeId.split('_')[0];
};
exports.getLanguageCodeFromLocale = getLanguageCodeFromLocale;
var buildLocale = function (localeId) { return ({
    id: localeId,
    bcp47Id: localeId.replace('_', '-'),
    languageCode: getLanguageCodeFromLocale(localeId),
    countryCode: getCountryCodeFromLocale(localeId),
}); };
exports.buildLocale = buildLocale;
// The parameters for the defaultLocale have to be confirmed by the CMS admins to be the desired ones.
var defaultLocale = buildLocale(DEFAULT_LOCALE_ID);
exports.defaultLocale = defaultLocale;
var defaultLocaleIdentifier = {
    _id: 'defaultLocaleIdentifier',
    _key: 'defaultLocaleIdentifier',
    _type: 'localeIdentifier',
    localeId: DEFAULT_LOCALE_ID,
    active: true,
    default: true,
    languageName: DEFAULT_LOCALE_NAME,
    languageCode: DEFAULT_LOCALE_LANGUAGE_CODE,
    country: {
        _id: 'defaultLocaleIdentifier-country',
        _key: 'defaultLocaleIdentifier-country',
        _type: 'country',
        countryName: DEFAULT_LOCALE_COUNTRY_NAME,
        countryCode: DEFAULT_LOCALE_COUNTRY_CODE,
        region: {
            _id: 'defaultLocaleIdentifier-region',
            _key: 'defaultLocaleIdentifier-region',
            _type: 'region',
            regionName: DEFAULT_LOCALE_REGION_NAME,
            regionCode: DEFAULT_LOCALE_REGION_CODE,
        },
        isRegionMaster: false,
    },
};
exports.defaultLocaleIdentifier = defaultLocaleIdentifier;
